module.exports = __webpack_public_path__ + "img/icon_folder_off.7e72ab0f.svg";